export const CDN_DOMAIN = "https://dentalbot.fra1.digitaloceanspaces.com/dentalbot-desktop";
export const IMAGE_DOMAIN = "https://dentalbot.fra1.digitaloceanspaces.com";